export interface NotificationModel {
  Title: string;
  Description: string;
  Action: boolean;
  Method?: string;
  read: boolean;
  type: string;
  date: string;
}

export interface SSENotificationMessage {
  feature?: string;
  title?: string;
  description?: string;
  type?: NotificationType;
  priority?: NotificationPriority;
  createDatetime?: string;
  redirectUrl?: string;
}

export enum NotificationType {
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  DEFAULT = 'DEFAULT',
}

export enum NotificationPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
  MEDIUM = 'MEDIUM',
}

export interface SSEConnectionConfig {
  maxReconnectAttempts?: number;
  reconnectDelay?: number;
  headers?: { [key: string]: string };
}

export interface SSEConnectionStatus {
  isConnected: boolean;
  reconnectAttempts: number;
  lastError?: string;
}

export interface NotificationDashboardHistoriesRequest {
  page: number;
  size: number;
  sortBy: string;
  order: 'asc' | 'desc';
  statuses?: ('DELIVERED' | 'READ')[] | readonly ('DELIVERED' | 'READ')[];
  startCreatedAt?: string;
  endCreatedAt?: string;
  feature?: string;
}

export interface NotificationDashboardHistoriesResponse {
  code: number;
  message: string;
  data: Array<NotificationHistoryItem>;
  totalData: number;
}
export interface MarkAsReadRequest {
  id: string;
}

export interface MarkAsReadResponse {
  code: number;
  message: string;
  data: boolean;
  totalData: number;
}

export interface NotificationHistoryItem {
  id: string;
  feature: string;
  title: string;
  description: string;
  status: string;
  updateDatetime: string;
  redirectUrl: string;
}

export interface NotificationHeaders {
  'x-api-key': string;
  'x-user-ip': string;
  'x-user-device': string;
  'x-user-location': string;
  'x-menu-id': string;
  Authorization: string;
}

export interface NotificationDisplayRequest {
  imid: string | null;
}

export interface NotificationDisplayFlags {
  onboard: boolean;
  approval: boolean;
  banner?: boolean;
}

export interface NotificationDisplayResponse {
  userId: string;
  flags: NotificationDisplayFlags;
}

export interface NotificationDisplaySeenRequest {
  imid: string;
  displayType: string;
}

export interface NotificationDisplaySeenResponse {
  // Response structure unknown - to be updated when API is documented
  [key: string]: unknown;
}
